(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smart-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('fa-cart-recs')) return;

    class FaCartRecs extends HTMLElement {
      connectedCallback() {
        this.cartIds = (this.dataset.cartIds || '').split(',').filter(Boolean);
        if (this.dataset.baseIds) {
          this.load();
        } else {
          this.finish();
        }
        this.watchCart();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.timer);
      }

      // Similar products / Bought together: fetch Shopify's picks for each base kit, merge them
      // in turn (1st of each, then 2nd of each...), then top up from the reserve.
      load() {
        const ids = this.dataset.baseIds.split(',').filter(Boolean);
        const url = (id) =>
          this.dataset.url + '?section_id=' + encodeURIComponent(this.dataset.sectionId) +
          '&product_id=' + id + '&limit=10&intent=' + this.dataset.intent;

        Promise.all(ids.map((id) => fetch(url(id)).then((r) => (r.ok ? r.text() : '')).catch(() => '')))
          .then((pages) => {
            const lists = pages.map((html) => {
              if (!html) return [];
              const doc = new DOMParser().parseFromString(html, 'text/html');
              return Array.from(doc.querySelectorAll('.fa-crecs__grid > .fa-crecs__item[data-product-id]'));
            });
            const seen = new Set(this.cartIds);
            let picks = [];
            const longest = lists.reduce((max, list) => Math.max(max, list.length), 0);
            for (let i = 0; i < longest; i++) {
              lists.forEach((list) => {
                const el = list[i];
                if (el && !seen.has(el.dataset.productId)) {
                  seen.add(el.dataset.productId);
                  picks.push(el);
                }
              });
            }
            if (this.dataset.shuffle === 'true') picks = this.shuffle(picks);

            const target = parseInt(this.dataset.target, 10) || 4;
            const reserve = this.querySelector('[data-fa-reserve]');
            if (reserve) {
              Array.from(reserve.children).forEach((el) => {
                if (picks.length < target && !seen.has(el.dataset.productId)) {
                  seen.add(el.dataset.productId);
                  picks.push(el);
                }
              });
              reserve.remove();
            }

            const grid = this.querySelector('.fa-crecs__grid');
            if (!grid || !picks.length) return this.hide();
            grid.innerHTML = '';
            picks.forEach((el) => grid.appendChild(el));
            this.loaded();
          })
          .catch((error) => {
            console.warn('Smart cart recommendations:', error);
            this.hide();
          });
      }

      finish() {
        const grid = this.querySelector('.fa-crecs__grid');
        if (!grid) return this.hide();
        const items = Array.from(grid.querySelectorAll(':scope > .fa-crecs__item'));
        if (!items.length) return this.hide();
        if (this.dataset.shuffle === 'true') this.shuffle(items).forEach((el) => grid.appendChild(el));
        this.loaded();
      }

      shuffle(list) {
        for (let i = list.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [list[i], list[j]] = [list[j], list[i]];
        }
        return list;
      }

      loaded() {
        // Lets review or wishlist apps re-scan cards that were added after page load.
        this.dispatchEvent(new CustomEvent('fa-recommendations:loaded', { bubbles: true }));
      }

      hide() {
        if (this.querySelector('.fa-crecs__empty')) return;
        this.hidden = true;
      }

      // When the shopper changes the cart on this page, re-render the section for the new cart.
      watchCart() {
        const root =
          document.querySelector('[data-section-type="cart-template"]') ||
          document.querySelector('form[action$="/cart"]');
        if (!root || root.contains(this) || !window.MutationObserver) return;
        this.observer = new MutationObserver(() => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.checkCart(), 800);
        });
        this.observer.observe(root, { childList: true, subtree: true });
      }

      checkCart() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const now = Array.from(new Set(cart.items.map((i) => String(i.product_id)))).sort().join(',');
            const before = Array.from(new Set(this.cartIds)).sort().join(',');
            if (now === before) return;
            return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(this.dataset.sectionId))
              .then((r) => (r.ok ? r.text() : ''))
              .then((html) => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const fresh = doc.querySelector('fa-cart-recs');
                if (fresh) {
                  this.replaceWith(fresh);
                } else {
                  this.cartIds = now.split(',').filter(Boolean);
                  this.hidden = true;
                }
              });
          })
          .catch(() => {});
      }
    }

    window.customElements.define('fa-cart-recs', FaCartRecs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('fa-recommendations')) return;

    class FaRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.url) {
          this.load();
        } else {
          this.finish();
        }
      }

      load() {
        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('fa-recommendations');
            if (!fresh) return this.hide();
            this.innerHTML = fresh.innerHTML;
            this.finish();
          })
          .catch((error) => {
            console.warn('Smart recommendations:', error);
            this.hide();
          });
      }

      finish() {
        const grid = this.querySelector('.fa-recs__grid');
        if (!grid) return this.hide();

        const currentId = this.dataset.productId;
        if (currentId) {
          grid.querySelectorAll('.fa-recs__item[data-product-id="' + currentId + '"]').forEach((el) => el.remove());
        }

        // Category guard for recommendations loaded after the page: keep only the same Product type.
        const wantedType = this.dataset.type;
        if (wantedType) {
          grid.querySelectorAll('.fa-recs__item[data-type]').forEach((el) => {
            if (el.dataset.type !== wantedType) el.remove();
          });
        }

        const items = Array.from(grid.querySelectorAll(':scope > .fa-recs__item'));
        if (!items.length) return this.hide();

        if (this.dataset.shuffle === 'true') {
          for (let i = items.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [items[i], items[j]] = [items[j], items[i]];
          }
          items.forEach((el) => grid.appendChild(el));
        }

        // Lets review or wishlist apps re-scan cards that were added after page load.
        this.dispatchEvent(new CustomEvent('fa-recommendations:loaded', { bubbles: true }));
      }

      hide() {
        if (this.querySelector('.fa-recs__empty')) return;
        this.hidden = true;
      }
    }

    window.customElements.define('fa-recommendations', FaRecommendations);
  })();

  } catch(e) { console.error(e); }
})();
})();
